// Canonical @id values must match hubspot.com/products/* entities exactly so
// Google merges the pricing page Offers into the existing product entity.
const PRODUCT_SCHEMA_CONFIG = {
  CONTENT: {
    productId: 'https://www.hubspot.com/products/content#product',
    name: 'Content Hub'
  },
  MARKETING: {
    productId: 'https://www.hubspot.com/products/marketing#product',
    name: 'Marketing Hub'
  },
  SALES: {
    productId: 'https://www.hubspot.com/products/sales#product',
    name: 'Sales Hub'
  },
  SERVICE: {
    productId: 'https://www.hubspot.com/products/service#product',
    name: 'Service Hub'
  },
  COMMERCE: {
    productId: 'https://www.hubspot.com/products/commerce#product',
    name: 'Commerce Hub'
  },
  DATA: {
    productId: 'https://www.hubspot.com/products/data#product',
    name: 'Data Hub'
  }
};
export function getProductSchemaConfig(productGroup) {
  return PRODUCT_SCHEMA_CONFIG[productGroup];
}